import { CONFIG } from "../../appConfig";

const prep = "prep/";

export default {
  /**
   * @desc Initiates the prepare flow logic
   * @returns {Object}
   * @memberof services.gma.prep
   * @example
   * services.gma.prep.initiate();
  
   */
  initiate() {
    return {
      endpoint: `${prep}initiate/`,
      method: "POST",
      origin: CONFIG.GMA_ORIGIN_URL
    };
  },

  /**
   * @desc Search driver details that's entered on driver lookup page
   * @param {Object} data {payload}
   * @returns {Object}
   * @memberof services.gma.prep
   * @example
   * services.gma.prep.searchProfile(data);
   * // dispatched results stored in `state.gmi.session.gbo.reservation`
   */
  searchProfile(data) {
    return {
      endpoint: `${prep}searchProfile/`,
      method: "POST",
      origin: CONFIG.GMA_ORIGIN_URL,
      data
    };
  },

  /**
   * @desc Continue with existing Driver Profile found
   * @returns {Object}
   * @memberof services.gma.prep
   * @example
   * services.gma.prep.driverConfirm();

   */
  driverConfirm() {
    return {
      endpoint: `${prep}driver/confirm/`,
      method: "POST",
      origin: CONFIG.GMA_ORIGIN_URL
    };
  },

  /**
   * @desc Update non loyalty profile
   * @param {Object} data {payload}
   * @returns {Object}
   * @memberof services.gma.prep
   * @example
   * data.payload = {
      additional_info: {
        update_profile_mode: "UPDATE"
      },
      first_name: "Miranda",
      last_name: "Pearce",
      address: {
        address_type: "HOME",
        city: "Boston",
        country_code: "US",
        country_subdivision_code: "MA",
        postal: "02110",
        street_addresses: [
          "1 South Station"
        ]
      },
      contact:{
        phones: [
          {
            phone_number: "6666666",
            phone_type: "HOME",
            priority: 1
          }
        ],
        email: "test@gmail.com",
      } 
    }
   * services.gma.prep.updateNonLoyaltyProfile(data);
   * // dispatched results stored in `state.gmi.session.gbo.profile`
   */
  updateNonLoyaltyProfile(data) {
    return {
      endpoint: `${prep}updateNonLoyaltyProfile/`,
      method: "POST",
      origin: CONFIG.GMA_ORIGIN_URL,
      data
    };
  },

  /**
   * @desc update loyalty profile for EC or EP Profile 
   * @returns {Object}
   * @memberof services.gma.prep
   * @example
   * data.payload = {
      additional_info: {
        update_profile_mode: "UPDATE"
      },
      first_name: "Miranda",
      last_name: "Pearce",
      address: {
        address_type: "HOME",
        city: "Boston",
        country_code: "US",
        country_subdivision_code: "MA",
        postal: "02110",
        street_addresses: [
          "1 South Station"
        ]
      },
      contact:{
        phones: [
          {
            phone_number: "6666666",
            phone_type: "HOME",
            priority: 1
          }
        ],
        email: "test@gmail.com",
      } 
      preference: {
        email_preference: {
          special_offers: true
        },
        source_code: "EPLUSECOM"
      }
    }
   * data.endpoint = {loyalty:'EC'};
   * data.endpoint = {loyalty:'EP'};
   * services.gma.prep.updateLoyaltyProfile();
   */
  updateLoyaltyProfile(data) {
    const { endpoint = { loyalty: "" }, payload = {} } = data;
    return {
      endpoint: `${prep}${endpoint.loyalty}/updateLoyaltyProfile/`,
      method: "POST",
      origin: CONFIG.GMA_ORIGIN_URL,
      data: payload
    };
  },

  /**
   * @desc creates a new non-loyalty profile
   * @param {Object} data {payload}
   * @returns {Object}
   * @memberof services.gma.prep
   * @example
   * services.gma.prep.createProfile(data);
   */
  createProfile(data) {
    return {
      endpoint: `${prep}createProfile/`,
      method: "POST",
      origin: CONFIG.GMA_ORIGIN_URL,
      data
    };
  },

  /**
   * @desc submit payment details provided in driver lookup and driver details page
   * @param {Object} data {payload}
   * @returns {Object}
   * @memberof services.gma.prep
   * @example
   *
   * const payload = { "payment_id":"SHSMKXRWGZTC1" }
   * services.gma.prep.submitPayment({payload});
   * // dispatched results stored in `session.gbo.reservation.selected_payment_method`
   */
  submitPayment(data) {
    return {
      endpoint: `${prep}submitPayment/`,
      method: "POST",
      origin: CONFIG.GMA_ORIGIN_URL,
      data
    };
  },

  /**
   * @desc clear payment details provided in the payment iframe
   * @returns {Object}
   * @memberof services.gma.prep
   * @example
   * services.gma.prep.clearPaymentDetails();
   */
  clearPaymentDetails() {
    return {
      endpoint: `${prep}clearPaymentDetails/`,
      method: "POST",
      origin: CONFIG.GMA_ORIGIN_URL
    };
  },

  /**
   * @desc submit enroll page clicking on Skip or Save My Rental Details button
   * @param {Object} data {payload}
   * @returns {Object}
   * @memberof services.gma.prep
   * @example
   * const payload = { "payment_id":"SHSMKXRWGZTC1" }
   * services.gma.prep.submit(data);
   */
  submit(data) {
    return {
      endpoint: `${prep}submit/`,
      method: "POST",
      origin: CONFIG.GMA_ORIGIN_URL,
      data
    };
  },
  /**
   * @desc Associate driver to a loyalty profile
   * @returns {Object}
   * @memberof services.gma.prep
   * @example
   * services.gma.prep.associateDriver();
   */
  associateDriver() {
    return {
      endpoint: `${prep}driver/associate`,
      method: "POST",
      origin: CONFIG.GMA_ORIGIN_URL
    };
  },
  /**
   * @desc Toggles the Young Renter Fee modal
   * @returns {Object}
   * @memberof services.gma.prep
   * @example
   * services.gma.prep.ackYoungFee();
   */
  ackYoungFee() {
    return {
      endpoint: `${prep}driver/ackYoungFee`,
      method: "POST",
      origin: CONFIG.GMA_ORIGIN_URL
    };
  }
};